import { inject, Injectable } from '@angular/core';
import { ViewTile } from '@ddv/dashboards';
import { ApiExecutorService, ApiServices } from '@ddv/http';
import { Observable, ReplaySubject, map, tap } from 'rxjs';

@Injectable()
export class DashboardNavService {
    private readonly ddvApiService = inject<ApiExecutorService>(ApiServices.ddvApi);

    public readonly viewTiles$: Observable<ViewTile[]>;

    private readonly viewTilesSubject = new ReplaySubject<ViewTile[]>(1);
    private viewTiles: ViewTile[] = [];
    private readonly removedViewTiles: ViewTile[] = [];

    constructor() {
        this.viewTiles$ = this.viewTilesSubject.asObservable();
    }

    fetchOpenViewTiles(clientCode: string): Observable<ViewTile[]> {
        return this.ddvApiService.invokeServiceWithParams<ViewTile[]>(clientCode, 'view-tiles')
            .pipe(
                map((viewTiles) => viewTiles.map((tile) => new ViewTile(tile))),
                tap((viewTiles) => {
                    this.viewTiles = viewTiles.filter((tile) => !this.removedViewTiles.some((removedTile) => removedTile.id === tile.id));
                    this.viewTilesSubject.next(this.viewTiles);
                }),
            );
    }

    loadViewTiles(): Observable<ViewTile[]> {
        return this.viewTiles$;
    }

    removeViewTile(id: number): void {
        this.removedViewTiles.push(...this.viewTiles.filter((tile) => tile.id === id));
        this.viewTiles = this.viewTiles.filter((tile) => tile.id !== id);
        this.viewTilesSubject.next(this.viewTiles);
    }
}
